import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect } from 'react';
import { Col, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import CopyVariable from '../../../common/CopyVariable';
import { INoteForm } from '../NoteForm';
import ScenarioSide from '../scenario/text-scenario/scenario-side';
import ScenarioHeader from '../ScenarioHeader';
import { MacBotActionKind } from '../types';

interface IFormData extends INoteForm {
  title: string;
  variables?: null | object;
}

export const GetUserInfoForm = ({ setShow, itemData }: { setShow: (item: boolean) => void; itemData: any }) => {
  const { t } = useTranslation();

  const variableFields = [
    { key: 'USER_NAME', value: '$:SUM_user_name' },
    { key: 'USER_LAST_NAME', value: '$:SUM_user_last_name' },
    { key: 'USER_FIRST_NAME', value: '$:SUM_user_first_name' },
    { key: 'USER_BIRTH_DATE', value: '$:SUM_user_birth_date' },
    { key: 'USER_AVATAR', value: '$:SUM_user_avatar' },
    {
      key: 'USER_CREATION_DATE_TIME',
      value: '$:SUM_user_creation_date_time',
    },
    { key: 'USER_LAST_CONNECTION', value: '$:SUM_user_last_connection' },
    { key: 'USER_PHONE', value: '$:SUM_user_phone' },
    { key: 'USER_EMAIL', value: '$:SUM_user_email' },
    { key: 'USER_COUNTRY_CODE', value: '$:SUM_user_country_code' },
    { key: 'USER_IS_ACTIVE', value: '$:SUM_user_is_active' },
    { key: 'USER_ROLE', value: '$:SUM_user_role' },
    { key: 'USER_TYPE', value: '$:SUM_user_type' },
    { key: 'USER_ACCOUNT_STATUS', value: '$:SUM_user_account_status' },
  ];

  const schema = Yup.object({
    title: Yup.string().max(30, t('SuperUserManager/blockTitleMaxLength')).required(t('SuperUserManager/blockTitleRequired')),
    variables: Yup.object().shape(
      variableFields.reduce((acc, field) => {
        acc[field.key] = Yup.string();
        return acc;
      }, {})
    ),
  });
  const {
    register,
    formState: { errors },
    reset,
    handleSubmit,
    control,
  } = useForm<IFormData>({
    resolver: yupResolver(schema) as any,
    defaultValues: {
      title: 'Get user info',
      variables: null,
    },
  });

  useEffect(() => {
    if (itemData) {
      reset({
        title: itemData?.title ?? '',
        variables: itemData?.variables ?? null,
        // notes: itemData?.notes
      });
    }
  }, [itemData]);

  const onSubmit = () => undefined;

  return (
    <React.Fragment>
      <ScenarioSide onSubmit={handleSubmit(onSubmit)} size="md">
        <ScenarioHeader
          type={MacBotActionKind.ShowGetUserInfo}
          onClose={() => {
            reset();
          }}
        />
        <div className="md:tw-p-6 tw-p-4 tw-bg-gray-50 tw-flex tw-flex-col tw-gap-y-4 tw-w-full">
          <Col xs={12}>
            <Form.Group>
              <Form.Label htmlFor="" className="tw-text-[#687076] tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-none">
                {t('SuperUserManager/blockTitle')}
              </Form.Label>
              <Form.Control
                maxLength={31}
                max={31}
                disabled
                className="tw-self-stretch tw-px-4 tw-py-3 tw-bg-white tw-rounded-md tw-shadow tw-border tw-border-gray-300"
                isInvalid={!!errors.title}
                {...register(`title`)}
              />
              <Form.Control.Feedback type="invalid" className="d-block font-poppins">
                {errors.title?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <div className="tw-h-px tw-border tw-border-solid tw-border-gray-200"></div>

          {variableFields.map((item, index) => (
            <React.Fragment key={index.toString()}>
              <Col xs={12} key={item?.key}>
                <Form.Group>
                  <CopyVariable text={item.value?.toString()} ignoreLowerCase />
                </Form.Group>
              </Col>
            </React.Fragment>
          ))}
        </div>
      </ScenarioSide>
    </React.Fragment>
  );
};
